import { SharePrizeInfo } from '@tencent/wphk-act-base-cgi';
import { QryAndFormatCouponItem } from '@tencent/wphk-act-base-types';
import { DetailBtnConfig } from '@tencent/wphk-act-base-ui';

/** 首页券状态 */
export enum C2CIndexCouponState {
  /** 已兑换 */
  exchanged,
  /** 可兑换 */
  exchangeable,
  /** 待解锁 */
  lock,
}
/** 弹窗券状态 */
export enum C2CDialogCouponState {
  /** 已使用 */
  used = 1,
  /** 已过期 */
  expired,
  /** 已领取 */
  received,
  /** 已领完 */
  limit,
  /** 待解锁 */
  locked,
  /** 可领取 */
  notReceived,
  /** 未知状态 */
  unknown,
}
export enum ShowType {
  'btn',
  'icon',
  'text',
}
export enum ShowLogoType {
  'gif',
  'png',
}
export enum ShowTextColor {
  'green' = '#00C553',
  'grey' = '#B3B3B3',
}

export type C2CCoupon = {
  /** 首页券状态 */
  indexStatus: C2CIndexCouponState;
  /** 弹窗券状态 */
  dialogStatus: C2CDialogCouponState;
  /** 分享活动券信息 */
  prizeInfo: SharePrizeInfo;
  /** 资格、券、活动信息 */
  couponInfo: QryAndFormatCouponItem;
  /** 按钮信息 */
  btnInfo: DetailBtnConfig;
  /** 首页券展示信息 */
  showInfo: {
    logoType: ShowLogoType;
    type: ShowType;
    text: string;
    color: ShowTextColor;
  };
  /** 是否是首个邀请券 */
  isfirstInvite: boolean;
};
